module.exports = __webpack_public_path__ + "img/1.7-711x800.f452e213.jpg";